import { useState } from "react";
import SectionTitle from "../components/SectionTitle";
import IconChips from "../components/IconChips";
import technology_list from "../technology_list";

const educationBG = [
  {
    location: "De La Salle University - Manila",
    date: "2022-2027",
    title: "BS Computer Science Major in Software Technology (Magna Cum Laude Standing)",
    desc: "DOST-SEI Merit Scholar; Dean's Lister; SPRINT - VP for External Relations; Google Developer Groups on Campus - UI UX Officer; Green Giant FM - Web Pool Member",
  },
  {
    location: "Las Pinas City National Science High School",
    date: "2016-2022",
    title: "Science, Technology, Engineering, and Mathematics",
    desc: "with Highest Honors; Campus Integrity Crusaders President; English Club Member",
  },
];

const experiencesBG = [
  {
    location: "Center for Human-Computer Innovations (CeHCI) Laboratory - DLSU",
    date: "SEP 2024 - OCT 2025",
    title: "Researcher",
    desc: ";Solo Thesis: Thesis: Investigating the Throwing Behavior of Beginner Dart Players: A Cluster Analysis Using Multi-Source Data",
  },
  {
    location: "BuiltaMart — Remote",
    date: "SEP 2024 - OCT 2025",
    title: "Software Engineeriing Intern",
    desc: ";Gained practical experience in Frontend and Backend development; Supported QA efforts by identifying issues. ",
  },
  {
    location: "SCALE NCR — Manila",
    date: "SEP 2024 - OCT 2025",
    title: "UI/UX Designer",
    desc: ";Designed a website directory for NCR startups",
  },
  {
    location: "Philippine Coding Camp — Remote",
    date: "FEB 2024 - MAY 2026",
    title: "Lecturer - Part-time",
    desc: ";Subjects: Web Dev, Digital Design, C++",
  },
  {
    location: "Philippine Coding Camp — Manila",
    date: "FEB 2025 - MAY 2025",
    title: "Website Developer",
    desc: ";Developed a static website for InnoVision International Conference.",
  },
  {
    location: "CARIONA — Remote",
    date: "AUG 2023 - AUG 2024",
    title: "Freelance Graphic Artist",
    desc: ";Created brand icons, logos, and illustrated product character patterns.",
  },
];

function CredentialContainer({ location, date, title, desc }) {
  let parsedDesc = desc.split(";");

  return (
    <div className="credz-container">
      <div className="credz-header">
        <p className="credz-loc">
          {location}
        </p>
        <p className="credz-year">{date}</p>
        {/* <p className="md:hidden lg:text-xl text-indigo-400 text-right text-sm">'22-'26</p> */}
      </div>
      <div>
        <p className="text-white credz-desc ">{title}</p>
        {parsedDesc.map((text, index) => (
          <p
            className={`credz-desc ${
              index > 0 ? "italic text-white/50 text-sm" : "text-white/75"
            }`}
            key={index}
          >
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}

function Overview() {
  return (
    <div className="md:w-2/3 md:text-base text-sm w-full px-10 m-auto text-white/75 leading-relaxed">
      <p className="text-justify">
        I am a 4th year{" "}
        <span className="text-fuchsia-400">
          BS Computer Science Major in Software Technology
        </span>{" "}
        student at De La Salle University. Currently, I specialize in <span className="text-indigo-400">UI/UX</span>  and
        <span className="text-indigo-400"> frontend Web Development</span>, however I also aspire to deeply explore the
        field of Cybersecurity and Cloud Computing technologies.
      </p><br/>
      <p className="text-justify pt-2 leading-loose">
        Ever since I was young, I've always had a passion for creativity.
        Building something valuable from scratch excites me and challenges me to
        create solutions that can meaningfully contribute to the community. At
        times when my 'programmer self' is at rest, I choose to spend my time
        <span className="text-indigo-400"> teaching kids, painting, baking cookies, or doing volunteer work.</span>
      </p><br/>
      <p className="text-justify pt-2 leading-loose">
        Driven by this blend of technical skills and creativity, <span className="text-fuchsia-400">I continuously seek opportunities to leverage what I know and deliver
        impactful solutions tailored for diverse customer needs.</span>
      </p>

    </div>
  );
}

function Experience() {
  return (
    <>
      {experiencesBG.map((item, index) => {
        return (
          <CredentialContainer
            key={index}
            location={item.location}
            date={item.date}
            title={item.title}
            desc={item.desc}
          />
        );
      })}
    </>
  );
}

function Education() {
  return (
    <>
      {educationBG.map((item, index) => {
        return (
          <CredentialContainer
            key={index}
            location={item.location}
            date={item.date}
            title={item.title}
            desc={item.desc}
          />
        );
      })}
    </>
  );
}

function ChooseSubsection({ selectedSubsection, setSelectedSubsection }) {
  return (
    <div className="pb-5">
      <div className="relative">
        <div className="inset-0 absolute h-2 border border-fuchsia-500 w-1/2 rounded-full self-center m-auto -z-50 hidden sm:block"></div>
        <div className="flex flex-row flex-wrap lg:gap-10 md:gap-5 gap-2 justify-center px-3 sm:text-base text-sm ">
          <button
            className={`sm:text-sm hover:bg-white/25 hover:text-white hover:border-white  border border-fuchsia-500/75 py-1 px-2 rounded-full ${
              selectedSubsection === "Overview"
                ? "bg-fuchsia-950 text-fuchsia-300"
                : "bg-gray-950 text-fuchsia-500/75 "
            }`}
            onClick={() => setSelectedSubsection("Overview")}
          >
            Overview
          </button>

          <button
            className={` hover:bg-white/25 hover:text-white hover:border-white  border border-fuchsia-500/75 py-1 px-2 rounded-full ${
              selectedSubsection === "Experience"
                ? "bg-fuchsia-950 text-fuchsia-300"
                : "bg-gray-950 text-fuchsia-500/75 "
            }`}
            onClick={() => setSelectedSubsection("Experience")}
          >
            Experience
          </button>

          <button
            className={` hover:bg-white/25 hover:text-white hover:border-white  border border-fuchsia-500/75 py-1 px-2 rounded-full ${
              selectedSubsection === "Education"
                ? "bg-fuchsia-950 text-fuchsia-300"
                : "bg-gray-950 text-fuchsia-500/75 "
            }`}
            onClick={() => setSelectedSubsection("Education")}
          >
            Education
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AboutMe() {
  const [selectedSubsection, setSelectedSubsection] = useState("Overview");

  const components = {
    Overview: <Overview />,
    Experience: <Experience />,
    Education: <Education />,
  };

  return (
    <section id="About" className="bg-gradient-to-b from-fuchsia-500/5 to-transparent">
      <SectionTitle text={"About Me"} componentStyle={"sec-title"} />
      <ChooseSubsection
        selectedSubsection={selectedSubsection}
        setSelectedSubsection={setSelectedSubsection}
      />

      {components[selectedSubsection] || null}

        <div id="Technologies" className="pt-10 pb-20 px-2 -mb-12 bg-gradient-to-t from-fuchsia-500/5 to-transparent w-full h-fit mx-auto rounded-sm">
        <p
          className="text-white text-center py-2 px-4"
        >
          Get to know some of the technologies that I use.{" "}
        </p>
        <div className="justify-center flex flex-row flex-wrap gap-4">
          {technology_list.map((technology, index) => (
            //   <div
            //     key={technology.name}
            //     className="opacity-0 animate-fade-slide-up "
            //     style={{ animationDelay: `${index * 100}ms` }}
            //   >
            <IconChips
              webURL={technology.URL}
              image={`/techLogos/${technology.image}`}
              techName={technology.name}
            />
            //   </div>
          ))}
        </div>
      </div>
    </section>
  );
}
